exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.showProject,.showProject1,.md-field.md-theme-default.showProject2{\n\tdisplay:none;\n}\n.singlecontent h2[data-v-singlehardware]{\n    width: 63%;\n}\n", ""]);

// exports
